import React from 'react';

const absoluteStyles = {
    position: "absolute",
    left: "0",
    right: "0",
    top: "50%"
};

export default function NotFound() {
    return (
        <p style={absoluteStyles}>Page Not Found</p>
    );
}



// WEBPACK FOOTER //
// ./src/presentation/NotFound.js